var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMugFronttest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 107.263,
    viewBox: "0 0 140 107.263",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.697,
    y1: 0.921,
    x2: 0.553,
    y2: 0.07,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9fa0aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dfe0e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.644,
    y1: -0.234,
    x2: 0.728,
    y2: 0.946,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1d2d8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d8e99"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.939,
    cy: 0.447,
    r: 0.967,
    gradientTransform: "matrix(0.999, 0.054, -0.028, 0.531, 0.014, 0.155)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbdce3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f8f8",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mug-fronttest",
    transform: "translate(0.099 -9.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M.814.514A175.976,175.976,0,0,0,35.587,4.552,143.579,143.579,0,0,0,68,.627",
    transform: "translate(34.602 111.388)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M-6.915.743A4.8,4.8,0,0,0-3.881,2.048,450.446,450.446,0,0,0,52.5,5.6c25.873,0,58.247-3.384,60.409-3.9S114.784.53,114.784.53s13.074,33.655,6.158,59.41-33.413,43.331-33.413,43.331a167.86,167.86,0,0,1-34.991,4.254c-17.656,0-35.632-4.254-35.632-4.254S-9.227,85.7-15.5,59.94-6.915.743-6.915.743Z",
    transform: "translate(16.94 8.65)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M-6.915.743A4.8,4.8,0,0,0-3.881,2.048,450.446,450.446,0,0,0,52.5,5.6c25.873,0,58.247-3.384,60.409-3.9S114.784.53,114.784.53s13.074,33.655,6.158,59.41S90.4,101.7,87.529,103.272s-17.336,4.254-34.991,4.254-33.185-2.981-35.632-4.254S-9.227,85.7-15.5,59.94-6.915.743-6.915.743Z",
    transform: "translate(16.94 8.646)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M-2.041,3.964S1.466,4.3,5.414,4.6s8.338.582,8.338.582S-3.3,32.034.195,57.461,27.276,108.2,27.276,108.2l-9.959-1.686s-25.4-23.323-30.371-49.05S-2.041,3.964-2.041,3.964Z",
    transform: "translate(22.757 6.693)",
    fill: "url(#radial-gradient)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMugFronttest);
export default __webpack_public_path__ + "static/media/mug-fronttest.d0661455a0d8d23c56a15a8e37a97734.svg";
export { ForwardRef as ReactComponent };